<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: null,
                    },
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <QuizForm :activity="activity" :questions="questions" :options="options" :meta="meta" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizForm from '@/Pages/Teacher/Quiz/Activity/Preview/QuizForm.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';

export default {
    components: {
        SmartBreadcrumbs,
        QuizForm,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'questions', 'activity'],
};
</script>
